import { render, staticRenderFns } from "./ClockField.vue?vue&type=template&id=348b826c&lang=pug&"
import script from "./ClockField.vue?vue&type=script&lang=js&"
export * from "./ClockField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/node/authoring/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('348b826c')) {
      api.createRecord('348b826c', component.options)
    } else {
      api.reload('348b826c', component.options)
    }
    module.hot.accept("./ClockField.vue?vue&type=template&id=348b826c&lang=pug&", function () {
      api.rerender('348b826c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/inspector/fields/ClockField.vue"
export default component.exports